<template>
  <div :class="{fullscreen:fullscreen}" class="tinymce-container" :style="{width:containerWidth}">
    <textarea :id="tinymceId" class="tinymce-textarea" />
    <div class="editor-custom-btn-container">
      <!-- <editorImage color="#1890ff" class="editor-upload-btn" @successCBK="imageSuccessCBK" /> -->
    </div>
  </div>
</template>

<script>
// import editorImage from './sub/editorImage'
import plugins from './plugins'
import toolbar from './toolbar'
// import load from './dynamicLoadScript'
// // why use this cdn, detail see https://github.com/PanJiaChen/tinymce-all-in-one
// const tinymceCDN = 'https://cdn.jsdelivr.net/npm/tinymce-all-in-one@4.9.3/tinymce.min.js'

export default {
  name: 'Tinymce',
  // components: { editorImage },
  props: {
    // 当前富文本id
    id: {
      type: String,
      default: function() {
        return (
          'vue-tinymce-' +
          +new Date() +
          ((Math.random() * 1000).toFixed(0) + '')
        )
      }
    },
    // 是否 不可编辑 ，默认否
    disable: {
      type: Boolean,
      default: false
    },
    // 当前富文本内容
    value: {
      type: String,
      default: ''
    },
    // 工具栏内容
    toolbar: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    // 菜单栏
    menubar: {
      type: String,
      default: 'file edit insert view format table'
    },
    height: {
      type: [Number, String],
      required: false,
      default: 360
    },
    width: {
      type: [Number, String],
      required: false,
      default: 'auto'
    }
  },
  data() {
    return {
      hasChange: false,
      hasInit: false,
      tinymceId: this.id,
      fullscreen: false,
      languageTypeList: {
        en: 'en',
        zh: 'zh_CN',
        es: 'es_MX',
        ja: 'ja'
      }
    }
  },
  computed: {
    containerWidth() {
      const width = this.width
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        // matches `100`, `'100'`
        return `${width}px`
      }
      return width
    }
  },
  watch: {
    // 监听到value变化，去手动改变值
    value(val) {
      // 是该富文本自己的数据变了，就不再通过setContent赋值
      window.tinymce.get(this.tinymceId).getContent() == val ? this.hasChange = false : this.hasChange = true
      if (this.hasChange && this.hasInit) {
        this.$nextTick(() => {
          window.tinymce.get(this.tinymceId).setContent(val || '')
        })
      }
    },
    disable(newValue, oldValue) {
      this.destroyTinymce()
      if (window.tinymce) {
        this.initTinymce()
      }
    }
  },
  mounted() {
    this.init()
    // setTimeout(() => {
    //   document.getElementById('mceu_34').style.display = 'none'
    // }, 1000)
  },
  activated() {
    if (window.tinymce) {
      this.initTinymce()
    }
  },
  deactivated() {
    this.destroyTinymce()
  },
  destroyed() {
    this.destroyTinymce()
  },
  methods: {
    init() {
      // dynamic load tinymce from cdn
      // load(tinymceCDN, err => {
      //   if (err) {
      //     this.$message.error(err.message)
      //     return
      //   }
        this.initTinymce()
      // })
    },
    initTinymce() {
      const _this = this
      window.tinymce.init({
        branding: false,
        readonly: this.disable ? 1 : 0,
        selector: `#${this.tinymceId}`,
        language: this.languageTypeList['zh'],
        height: this.height,
        body_class: 'panel-body ',
        object_resizing: false,
        convert_urls: false,
        toolbar: this.disable ? [] : this.toolbar.length > 0 ? this.toolbar : toolbar,
        menubar: this.disable ? '' : this.menubar,
        plugins: this.disable ? [] : plugins,
        end_container_on_empty_block: true,
        powerpaste_word_import: 'clean',
        code_dialog_height: 450,
        code_dialog_width: 1000,
        paste_data_images:true,
        images_file_types: 'jpeg,jpg,png,gif,bmp,webp,svg',
        advlist_bullet_styles: 'square',
        advlist_number_styles: 'default',
        imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        default_link_target: '_blank',
        link_title: false,
        nonbreaking_force_tab: true, // inserting nonbreaking space &nbsp; need Nonbreaking Space Plugin
        images_upload_url: `${this.$prefixUrl.baseService}/file/manager/imageUpload`, // 指定一个接受上传文件的后端处理程序地址
        cri: {
              white_domains: ['api-test.999time.cn', 'api-dev.999time.cn','ca.xdqtech.com','xdqtech.com'],
              uploader: function(images, success, error) {
                  if(!images) {
                      return !1;
                  }
                  let reqData={
                    urls:images
                  }
                  _this.$apiData.outImageSave(reqData).then((res)=>{
                      if(res.data&&res.data.code == '0000') {
                          success(res.data);
                          return !1;
                      }else{
                        _this.$message.error((res && res.data.msg) || "图片本地化请求出2了");
                      }
                  })
              }
          },
        // 初始化结束后执行
        init_instance_callback: editor => { 
          if (_this.value) {
            editor.setContent(_this.value)
          }
          _this.hasInit = true
          editor.on('NodeChange Change KeyUp SetContent', () => {
            // 监听到值变化了, 去把变化值传出去。
            this.$emit('input', editor.getContent())
          })
        },
        // 初始化前执行
        setup(editor) {  
          editor.on('FullscreenStateChanged', e => {
            _this.fullscreen = e.state
          })
        },
        // 文件上传
        file_picker_callback: (callback, value, meta) => {
          // Provide file and text for the link dialog
            //要先模拟出一个input用于上传本地文件
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('value', '');
            input.click();
            input.onchange = function() {
              var file = this.files[0];
            }
        },
        images_upload_handler: function (blobInfo, succFun, failFun) {
        var xhr, formData;
        var file = blobInfo.blob();//转化为易于理解的file对象
        xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.open('POST', `${_this.$prefixUrl.baseService}/file/manager/imageUpload`);
        xhr.onload = function() {
            var json;
            if (xhr.status != 200) {
                failFun('HTTP Error: ' + xhr.status);
                return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.data.reqPath != 'string') {
                failFun('Invalid JSON: ' + xhr.responseText);
                return;
            }
            succFun(json.data.reqPath);
        };
        formData = new FormData();
        formData.append('file', file, file.name );//此处与源文档不一样
        xhr.send(formData);
      }
        // 图片上传——整合七牛上传
        // images_dataimg_filter(img) {
          // console.log(img)
        //   setTimeout(() => {
        //     const $image = $(img);
        //     $image.removeAttr('width');
        //     $image.removeAttr('height');
        //     if ($image[0].height && $image[0].width) {
        //       $image.attr('data-wscntype', 'image');
        //       $image.attr('data-wscnh', $image[0].height);
        //       $image.attr('data-wscnw', $image[0].width);
        //       $image.addClass('wscnph');
        //     }
        //   }, 0);
        //   return img
        // },
        // images_upload_handler(blobInfo, success, failure, progress) {
        //   progress(0);
        //   const token = _this.$store.getters.token;
        //   getToken(token).then(response => {
        //     const url = response.data.qiniu_url;
        //     const formData = new FormData();
        //     formData.append('token', response.data.qiniu_token);
        //     formData.append('key', response.data.qiniu_key);
        //     formData.append('file', blobInfo.blob(), url);
        //     upload(formData).then(() => {
        //       success(url);
        //       progress(100);
        //     })
        //   }).catch(err => {
        //     failure('出现未知问题，刷新页面，或者联系程序员')
        //     console.log(err);
        //   });
        // }
      })
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId)
      if (this.fullscreen) {
        tinymce.execCommand('mceFullScreen')
      }
      if (tinymce) {
        tinymce.destroy()
      }
    },
    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value)
    },
    getContent() {
      window.tinymce.get(this.tinymceId).getContent()
    },
    imageSuccessCBK(arr) {
      const _this = this
      arr.forEach(v => {
        window.tinymce
          .get(_this.tinymceId)
          .insertContent(`<img class="wscnph" src="${v.url}" >`)
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.tinymce-container {
  position: relative;
  line-height: normal;
}
.tinymce-container >>> .mce-fullscreen {
  z-index: 10000;
}
.tinymce-container >>> .mce-menubar {
  border: none;
}
.tinymce-textarea {
  visibility: hidden;
  z-index: -1;
}
.editor-custom-btn-container {
  position: absolute;
  right: 4px;
  top: 4px;
  /*z-index: 2005;*/
}
.fullscreen .editor-custom-btn-container {
  z-index: 10000;
  position: fixed;
}
.editor-upload-btn {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/base/editor/index.vue